export function prepareFormPayload(formData, initEventPayload = {}) {
	if (!formData || !formData.dataTargetId) {
		return null;
	}

	const payload = { ...initEventPayload };
	payload.name = payload.name || formData.name;
	payload.arguments = payload.arguments || {};
	payload.arguments.dataTargetName = formData.dataTargetName;
	payload.arguments.formName = formData.name;
	payload.metaData = payload.metaData || {};
	payload.configurationArguments = payload.configurationArguments || {};
	payload.configurationArguments.smartCaptureFormID = formData.smartCaptureFormId;

	delete payload.dataExtensionId;
	delete payload.schema;

	if (formData.dataTargetTypeId === 1) {
		payload.dataExtensionId = formData.dataTargetId;
	} else if (formData.dataTargetTypeId === 2) {
		payload.schema = {
			"fields": [
				{
					"name": "formID",
					"dataType": "number",
					"maxLength": "",
					"isNullable": false,
					"defaultValue": ""
				}
			],
			"sendableCustomObjectField": "EmailAddress",
			"sendableSubscriberField": "EmailAddress"
		};
	}

	return payload;
}